import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import GoogleAnalytics from '../../../util/Ga.js';
// ES6 className-style
class Trusted extends PreLoginSessionCheck {

  render() {
	 
  	return(
		<section className="product-main">
			<div className="container">  
				<h2 className="mar-adjust">Trusted by the best</h2> 
				<div className="row">
					<div className="col-md-6">
						<div className="trust-box">
							<h3 className="sub-heading">Academic collaborations</h3>
							<div className="l-img">
								<div className="trust-img"> <img src="../img/t11.png" alt="" /> </div>
								<p>University of Cambridge</p>
							</div>
							<div className="r-img">
								<div className="trust-img"><img src="../img/t21.png" alt="" /></div>
								<p>Raffles Institution, Singapore</p>
							</div>
							<div className="clear"></div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="trust-box">
							<h3 className="sub-heading">Successfully implemented since 2001</h3>
							<div className="l-img">
								<div className="trust-img"> <img src="../img/t31.png" alt="" /> </div>
								<p>CBSE, ICSE and IGCSE schools</p>
							</div>
							<div className="r-img">
								<div className="trust-img"><img src="../img/t41.png" alt="" /></div>
								<p>Singapore MOE schools</p>
							</div>
							<div className="clear"></div>
						</div>
					</div>
				</div>
				
				</div>
			</section>
  		);
  	}
}

export default Trusted; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Trusted.js